
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import BlocSmsForm from '@/components/forms/SmsBlocTextForm.vue'

const smsModule = namespace('sms')

@Component({
  components: {
    BaseCardContainer,
    BlocSmsForm
  }
})
export default class BlocTextCreate extends Vue {
  @smsModule.Action('createSmsBlocTextAction') createSmsBlocText: any
  @smsModule.Action('getSmsBlocTextsAction') getSmsBlocTexts: any

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createSmsBlocText(data).then(async (data: any) => {
      this.getSmsBlocTexts()
      this.$router.push({name: 'BlocSmsList'})
    })
  }

  onCancel() {
    this.$router.replace({name: 'BlocSmsList'})
  }
}
